import { render, staticRenderFns } from "./EditAsset.vue?vue&type=template&id=b55e6a2e&scoped=true&"
import script from "./EditAsset.vue?vue&type=script&lang=js&"
export * from "./EditAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55e6a2e",
  null
  
)

export default component.exports